



































































































import { Component, Vue } from 'vue-property-decorator';
import Headerhome from '@/components/headerhome.vue';
import ajax from '@/lib/ajax';

@Component({
  components: { Headerhome },
})
export default class TransferDetail extends Vue {
  transfer: any={};
  async created() {
    const payload = {
      orderId: this.$route.params.orderId,
    };
    const response = await ajax.post(
      'api/services/app/Booking/GetTransferOrderById',
      payload
    );

    this.transfer = response.data.result;


  }
}
